/**
 * Copyright (c) 2021
 *
 * Contains the representation of a SubscriptionStateEnumType
 *
 * @summary SubscriptionStateEnumType enum definition
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2021-08-17 10:21:56
 * Last modified  : 2021-08-17 16:40:37
 */

const SubscriptionStateEnumType = {
    SUMMER: 'summer',
    ACTIVE: 'active',
    CANCELED: 'canceled',
    EXPIRED: 'expired',
    ON_HOLD: 'on_hold',
    PAST_DUE: 'past_due',
    SOFT_FAILURE: 'soft_failure',
    TRIALING: 'trialing',
    TRIAL_ENDED: 'trial_ended',
    UNPAID: 'unpaid',
    ASSESSING: 'assessing',
    FAILED_TO_CREATE: 'failed_to_create',
    PAUSED: 'paused',
    PENDING: 'pending',
    SUSPENDED: 'suspended'
}

export default SubscriptionStateEnumType
